import request from "@/config/axios";
import type { DictResType } from "./types";

export const getDictListApi = (
  data
): Promise<GlobalResponseType<DictResType[]>> => {
  return request.post({ url: "/api/v5/document/dict/GetSelectedDict", data });
};
